import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './CSS/app_list.css';

const AppList = () => {
  const [apps, setApps] = useState([]);
  const [editingApp, setEditingApp] = useState(null);
  const [newName, setNewName] = useState('');
  const [newDescription, setNewDescription] = useState('');

  useEffect(() => {
    fetchApps();
  }, []);

  const fetchApps = async () => {
    try {
      const res = await axios.get('https://weynibirhan.com.et/get_apps.php');
      setApps(res.data || []);
    } catch (err) {
      console.error('Failed to fetch apps:', err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this app?')) return;
    try {
      await axios.post('https://weynibirhan.com.et/delete_app.php', { id });
      fetchApps();
    } catch (err) {
      console.error('Delete failed:', err);
    }
  };

  const handleEdit = (app) => {
    setEditingApp(app);
    setNewName(app.name);
    setNewDescription(app.description);
  };

  const handleUpdate = async () => {
    try {
      await axios.post('https://weynibirhan.com.et/update_app.php', {
        id: editingApp.id,
        name: newName,
        description: newDescription,
      });
      setEditingApp(null);
      fetchApps();
    } catch (err) {
      console.error('Update failed:', err);
    }
  };

  return (
    <div className="app-list-container">
      <h2>Latest Apps</h2>
	  <br/>
      <table className="app-table">
        <thead>
          <tr>
            <th>App Name</th>
            <th>Description</th>
            <th>Download</th>
            {/*<th>Actions</th>*/}
          </tr>
        </thead>
        <tbody>
          {apps.map((app) => (
            <tr key={app.id}>
              <td>
                {editingApp?.id === app.id ? (
                  <input value={newName} onChange={(e) => setNewName(e.target.value)} />
                ) : (
                  app.name
                )}
              </td>
              <td>
                {editingApp?.id === app.id ? (
                  <textarea value={newDescription} onChange={(e) => setNewDescription(e.target.value)} />
                ) : (
                  app.description
                )}
              </td>
              <td>
                <a href={`https://weynibirhan.com.et/${app.image_url}`} download>
                  Download
                </a>
              </td>
			  {/* <td>
                {editingApp?.id === app.id ? (
                  <>
                    <button onClick={handleUpdate}>Save</button>
                    <button onClick={() => setEditingApp(null)}>Cancel</button>
                  </>
                ) : (
                  <>
                    <button onClick={() => handleEdit(app)}>Edit</button>
                    <button onClick={() => handleDelete(app.id)}>Delete</button>
                  </>
                )}
		  </td>*/}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AppList;
